import { useState, useRef } from 'react';

export const useLongPress = (callback, duration = 500) => {
  const [isPressed, setIsPressed] = useState(false);
  const timerRef = useRef(null);

  const start = () => {
    setIsPressed(true);
    timerRef.current = setTimeout(() => {
      callback?.();
    }, duration);
  };

  const stop = () => {
    setIsPressed(false);
    clearTimeout(timerRef.current);
  };

  return {
    handlers: {
      onMouseDown: start,
      onMouseUp: stop,
      onMouseLeave: stop,
      onTouchStart: start,
      onTouchEnd: stop
    },
    isPressed
  };
};
